import LeadgenForm from '@/entities/LeadgenForm';
import SourceProfile from '@/entities/SourceProfile';
import api from '@/services/Api';

export default {
  connect(platform, id, country, chargeExtraBrand) {
    const data = {
      platform,
      id,
      country,
      charge_extra_brands: chargeExtraBrand,
    };
    return api().post('/source-profile', data)
      .then(resp => new SourceProfile(resp));
  },

  disconnect(sourceProfileId) {
    return api().delete('/source-profile/' + sourceProfileId);
  },

  get(id) {
    return api().get('/source-profile/' + id)
      .then(resp => new SourceProfile(resp));
  },

  refresh(id) {
    return api().post('/source-profile/' + id + '/refresh');
  },

  refreshDetails(id) {
    return api().post('/source-profile/' + id + '/details/refresh')
      .then(resp => new SourceProfile(resp));
  },

  generatePostAiScores(id) {
    return api().post('/source-profile/' + id + '/generate-post-ai-scores');
  },

  refreshLeadgenForms(id) {
    return api().post('/source-profile/' + id + '/leadgen-forms/refresh')
      .then(resp => resp.map(item => new LeadgenForm(item)));
  },
};
